import React from 'react';
import './Home.scss'
import ProductList from "../components/ProductList/ProductList";
import VideoList from "../components/VideoList/VideoList";
import {IProduct, IReviewItem} from "../types/types";
import ReviewList from "../components/ReviewList/ReviewList";

import videoOne from './../assets/video/1.mp4'
import videoTwo from './../assets/video/2.mp4'
import videoThree from './../assets/video/3.mp4'
import videoFour from './../assets/video/4.mp4'
import videoFive from './../assets/video/5.mp4'

import OneOneImage from "./../assets/images/1-1.png"
import OneTwoImage from './../assets/images/1-2.png'
import TwoOneImage from './../assets/images/2-1.png'
import TwoTwoImage from './../assets/images/2-2.png'
import TwoThreeImage from './../assets/images/2-3.png'
import ThreeOneImage from './../assets/images/3-1.png'
import ThreeTwoImage from "./../assets/images/3-2.png"
import ThreeThreeImage from "./../assets/images/3-3.png"
import FourOneImage from './../assets/images/4-1.png'
import FourTwoImage from "./../assets/images/4-2.png"
import FourThreeImage from "./../assets/images/4-3.png"
import FiveOneImage from './../assets/images/5-1.png'
import FiveTwoImage from "./../assets/images/5-2.png"
import SixOneImage from './../assets/images/6.png'
import SevenOneImage from './../assets/images/7.png'
import EightOneImage from "./../assets/images/8.png"
import NineOneImage from './../assets/images/9-1.png'
import NineTwoImage from "./../assets/images/9-2.png"
import NineThreeImage from "./../assets/images/9-3.png"
import TenOneImage from './../assets/images/10-1.png'
import TenTwoImage from "./../assets/images/10-2.png"
import ElevenThreeImage from "./../assets/images/11.png"
import TwelveThreeImage from "./../assets/images/12.png"
import ThirteenOneImage from './../assets/images/13-1.png'
import ThirteenTwoImage from "./../assets/images/13-2.png"
import FourteenOneImage from './../assets/images/14-1.png'
import FourteenTwoImage from "./../assets/images/14-2.png"
import FourteenThreeImage from "./../assets/images/14-3.png"
import FifteenOneImage from './../assets/images/15.png'
import SixtyOneImage from "./../assets/images/16.png"
import SeventyOneImage from './../assets/images/17-1.png'
import SeventyTwoImage from "./../assets/images/17-2.png"
import SeventyThreeImage from "./../assets/images/17-3.png"
import EightyOneImage from './../assets/images/18.png'
import NinetyOneImage from "./../assets/images/19.png"
import TwentyImage from "./../assets/images/20.png"
import TwentyOneImage from "./../assets/images/21.png"
import TwentyTwoImage from "./../assets/images/22.png"
import TwentyThreeImage from "./../assets/images/23.png"
import reviewOne from '../assets/reviews/1.png'
import reviewTwo from '../assets/reviews/2.png'
import reviewThree from '../assets/reviews/3.png'
import reviewFour from '../assets/reviews/4.png'
import reviewFive from '../assets/reviews/5.png'
import reviewSix from '../assets/reviews/6.png'
import reviewSeven from '../assets/reviews/7.png'
import reviewEight from '../assets/reviews/8.png'
import {NavLink} from "react-router-dom";


const reviewList:Array<IReviewItem>=[
    {id:1,rsc:reviewOne},
    {id:2,rsc:reviewTwo},
    {id:3,rsc:reviewThree},
    {id:4,rsc:reviewFour},
    {id:5,rsc:reviewFive},
    {id:6,rsc:reviewSix},
    {id:7,rsc:reviewSeven},
    {id:8,rsc:reviewEight},
]


const productsList:Array<IProduct> = [
    {id: '1',images:[
            {id:1,src:OneOneImage},{id:2,src:OneTwoImage}
        ]},
    {id: '2',images:[
            {id:1,src:TwoOneImage},{id:2,src:TwoTwoImage},{id:3,src:TwoThreeImage}
        ]},
    {id: '3',images:[
            {id:1,src:ThreeOneImage},{id:2,src:ThreeTwoImage},{id:3,src:ThreeThreeImage}
        ]},
    {id: '4',images:[
            {id:1,src:FourOneImage},{id:2,src:FourTwoImage},{id:3,src:FourThreeImage}
        ]},
    {id: '5',images:[
            {id:1,src:FiveOneImage},{id:2,src:FiveTwoImage}
        ]},
    {id: '6',images:[
            {id:1,src:SixOneImage}
        ]},
    {id: '7',images:[
            {id:1,src:SevenOneImage}
        ]},
    {id: '8',images:[
            {id:1,src:EightOneImage}
        ]},
    {id: '9',images:[
            {id:1,src:NineOneImage},{id:2,src:NineTwoImage},{id:3,src:NineThreeImage}
        ]},
    {id: '10',images:[
            {id:1,src:TenOneImage},{id:2,src:TenTwoImage}
        ]},
    {id: '11',images:[
            {id:1,src:ElevenThreeImage}
        ]},
    {id: '12',images:[
            {id:1,src:TwelveThreeImage}
        ]},
    {id: '13',images:[
            {id:1,src:ThirteenOneImage},{id:2,src:ThirteenTwoImage}
        ]},
    {id: '14',images:[
            {id:1,src:FourteenOneImage},{id:2,src:FourteenTwoImage},{id:3,src:FourteenThreeImage}
        ]},
    {id: '15',images:[
            {id:1,src:FifteenOneImage}
        ]},
    {id: '16',images:[
            {id:1,src:SixtyOneImage}
        ]},
    {id: '17',images:[
            {id:1,src:SeventyOneImage},{id:2,src:SeventyTwoImage},{id:3,src:SeventyThreeImage}
        ]},
    {id: '18',images:[
            {id:1,src:EightyOneImage}
        ]},
    {id: '19',images:[
            {id:1,src:NinetyOneImage}
        ]},
    {id: '19',images:[
            {id:1,src:TwentyImage}
        ]},
    {id: '21',images:[
            {id:1,src:TwentyOneImage},{id:2,src:TwentyTwoImage},{id:3,src:TwentyThreeImage}
        ]},
]

interface IVideoItem {
    id:number
    url:string
}
const videoList:Array<IVideoItem>=[
    {id:1, url:videoOne},
    {id:2, url:videoTwo},
    {id:3, url:videoThree},
    {id:4, url:videoFour},
    {id:5, url:videoFive},
]


const stepsComponents = {
    0: <ProductList list={productsList}/>,
    1: <VideoList list={videoList}/>,
    2: <ReviewList list={reviewList}/>
}

const titleTab={
    0:"Фотографии",
    1:"Видео",
    2:"Отзывы",
}

const Home = () => {
    const [step, setStep] = React.useState<number>(0);
    const Step = stepsComponents[step]
    return (
        <div className='home'>
            <div className='home__switch'>
                <div className='home__switch__list'>
                    {Object.keys(stepsComponents).map(key=>
                    <div
                        onClick={()=>setStep(Number(key))}
                        className={`home__switch__list__item ${`${step}` === key ? 'active':''}`}
                        key={key}
                    >{titleTab[key]}</div>
                    )}
                </div>
            </div>
            {Step}
        </div>
    );
};

export default Home;